/* eslint react/prop-types:off */
import React from 'react';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import routes from '../routes';
import routesAR from '../routes-ar';

const Root = ({ store }) => (
  <Provider store={store}>
    <Router history={browserHistory}>
      { routes }
      { routesAR }
    </Router>
  </Provider>
);

export default Root;



// WEBPACK FOOTER //
// ./js/components/Root.js